import { DisabilityType } from '../api/app-types/disability-type.app';

export const mockDisabilityType: DisabilityType = {
	id: 1,
	remark: 'Mock Disability Type',
	categoryDiagnoses: [
		{
			id: 1,
			description: 'Mock Description 1',
		},
	],
};

export const mockDisabilityType2: DisabilityType = {
	id: 2,
	remark: 'Mock Disability Type 2',
	categoryDiagnoses: [
		{
			id: 2,
			description: 'Mock Description 2',
		},
	],
};

export const mockDisabilityTypes: DisabilityType[] = [mockDisabilityType, mockDisabilityType2];
